/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Mon May 09 2022
*  File : fanpage-server-sdk-dev.ts
*******************************************/

import { SdkServer } from "../../../../fanpage/it/lib/modules/SdkServer.js";
import { config } from "../../../../fanpage/it/lib/config/production.js";

window['ServerSdk'] = SdkServer(config);
window['ServerSdk'].init();